import "./index.css";

interface AppInfo {
  name: string;
  description: string;
  url: string;
  date: string;
}

const apps: AppInfo[] = [
  {
    name: "d-sns",
    description: "WebRTCを使ってP2Pで投稿を共有するSNS。OPFSとsqlite-wasmで、ブラウザのローカル環境にのみデータを保存。",
    url: "https://d-sns.umigame.app",
    date: "2025年11月28日",
  },
  {
    name: "Simple Find Web",
    description: "WebAssembly と File System Access API を使ってローカルディレクトリを文字列検索する Web アプリ",
    url: "https://find.umigame.app",
    date: "2025年11月20日",
  },
  {
    name: "Hyper Binary Editor",
    description: "Web上でバイナリファイルを編集するサイト。パフォーマンス上の工夫がしてある",
    url: "https://bin.umigame.app",
    date: "2025年11月18日",
  },
  {
    name: "ローカル画像WebPコンバーター",
    description: "File System Access APIを使ってローカル画像をWebPに変換するサイト",
    url: "https://webp.umigame.app",
    date: "2025年11月13日",
  },
  {
    name: "あなたの人生、映画化したらどうなる？",
    description: "いくつかの質問に答えて、あなたの人生をAIに映画化させるサイト",
    url: "https://life-movie-ai.umigame.app",
    date: "2025年11月7日",
  },
  {
    name: "Iced",
    description: "1日経たないと投稿が公開されないSNS。",
    url: "https://iced.umigame.app",
    date: "2025年10月31日",
  },
  {
    name: "CODE MAGICA",
    description: "プログラミングでバトルする簡易RPG",
    url: "https://coding-battle.umigame.app",
    date: "2025年10月31日",
  },
  {
    name: "異世界RPGクラス診断90",
    description: "異世界RPGのクラスを診断してキャラが勝手に冒険するというコンセプトのWebアプリ",
    url: "https://isekai.umigame.app",
    date: "2025年10月30日",
  },
  {
    name: "ハロウィンクイズ",
    description: "ハロウィンの知識を問うクイズWebアプリ",
    url: "https://halloween.umigame.app",
    date: "2025年10月20日",
  },
];

export function App() {
  return (
    <div className="container">
      <header className="header">
        <h1>作成したアプリ一覧</h1>
      </header>

      <main className="main">
        <ul className="app-list">
          {apps.map((app, index) => (
            <li key={index} className="app-item">
              <a
                href={app.url}
                target="_blank"
                rel="noopener noreferrer"
                className="app-link"
              >
                <h2 className="app-name">{app.name} </h2>
                <p className="app-description">{app.description}</p>
                <p className="app-date">{app.date} 公開</p>
              </a>
            </li>
          ))}
        </ul>
      </main>
    </div>
  );
}

export default App;
